import { NSButton, NSCard } from 'bricks';
import React, { useState } from 'react';
import {
    faArrowLeftToLine, faArrowRight, faArrowLeft, faCaretDown,
} from '@fortawesome/pro-solid-svg-icons';
import './ProFormaWizardStepper.scss';
import RenderIf from 'components/RenderIf/RenderIf';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import BackOfEnvelopeKeyValues from 'components/BackOfEnvelopeKeyValues/BackOfEnvelopeKeyValues';
import { useGetBackOfEnvelope } from 'views/DealDashboard/BOE/hooks/useGetBOE';
import useAuthContext from 'contexts/AuthContext';
import { useProFormaWizard } from '../../context/ProFormaWizardProvider';

const ProFormaWizardStepper = () => {
    const {
        proForma, saveAsDraft, currentStep, handleNextStep, handlePrevStep, isLoading,
    } = useProFormaWizard();

    const { selectedOrganizationId } = useAuthContext();

    const [showBackOfEnvelopeView, setShowBackOfEnvelopeView] = useState(false);

    const steps = ['Basic information', 'Development', 'Operations'];

    const handleViewOriginalScenario = () => {
        setShowBackOfEnvelopeView(!showBackOfEnvelopeView);
    };

    const { data: boeScenario } = useGetBackOfEnvelope({
        orgId: selectedOrganizationId!,
        scenarioId: Number(proForma?.boeScenario?.id || 0),
        enabled: !!selectedOrganizationId && !!proForma?.boeScenario?.id,
    });

    return (
        <NSCard className="ProFormaWizardStepper__card shadow">
            <div className="d-flex mx-2 justify-content-between align-items-center">
                <NSButton
                    className="ProFormaWizardStepper__backButton"
                    icon={currentStep === 1 ? faArrowLeftToLine : faArrowLeft}
                    color="secondary"
                    text={currentStep === 1 ? 'Exit' : 'Back'}
                    callback={handlePrevStep}
                    disabled={isLoading}
                />

                <ol className="ProFormaWizardStepper__horizontalStepper">
                    {steps.map((step, index) => (
                        <li
                            key={step}
                            className={`ProFormaWizardStepper__horizontalStepper__item 
                                ${currentStep === index + 1 ? 'ProFormaWizardStepper__horizontalStepper__item--active' : ''}`}
                        >
                            {currentStep === index + 1 ? <div className="ProFormaWizardStepper__horizontalStepper__small--active" /> : null}
                            <p
                                className={`ProFormaWizardStepper__horizontalStepper__title ${currentStep === index + 1
                                    ? 'ProFormaWizardStepper__horizontalStepper__title--active' : ''
                                }`}
                            >
                                {step}
                            </p>
                        </li>
                    ))}
                </ol>

                <div className="d-flex justify-content-end">
                    <RenderIf isTrue={proForma?.boeScenario?.id && boeScenario}>
                        <div>
                            <Dropdown
                                isOpen={showBackOfEnvelopeView}
                                toggle={handleViewOriginalScenario}
                            >
                                <DropdownToggle
                                    className="d-flex align-items-center"
                                    color="secondary"
                                >
                                    <span>View original scenario</span>
                                    <FontAwesomeIcon icon={faCaretDown} className="ml-1" />
                                </DropdownToggle>
                                <DropdownMenu className="pb-3">
                                    <div className="p-3 overflow-auto">
                                        <BackOfEnvelopeKeyValues
                                            boeScenario={boeScenario}
                                            className="BackOfEnvelopeKeyValues__wizard-height"
                                        />
                                    </div>
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                    </RenderIf>

                    <NSButton
                        color="secondary"
                        text="Save draft"
                        className="mx-2"
                        callback={saveAsDraft}
                        disabled={isLoading}
                        isLoading={isLoading}
                    />
                    <NSButton
                        className="ProFormaWizardStepper__nextButton text-nowrap"
                        icon={faArrowRight}
                        iconPosition="right"
                        color="primary"
                        text={currentStep === 3 ? 'Finalize' : 'Next'}
                        callback={handleNextStep}
                        isLoading={isLoading}
                        disabled={isLoading}
                    />
                </div>
            </div>
        </NSCard>
    );
};

export default ProFormaWizardStepper;
